import { Component } from '@angular/core';
import { SkipUserComponentVersionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'User Component Versions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-skipusercomponentversion-form',
    templateUrl: './skipusercomponentversion.form.component.html'
})
export class SkipUserComponentVersionFormComponent extends BaseFormComponent {
    public record!: SkipUserComponentVersionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'userComponentLibraries', sectionName: 'User Component Libraries', isExpanded: false },
            { sectionKey: 'userComponentFeedbacks', sectionName: 'User Component Feedbacks', isExpanded: false },
            { sectionKey: 'conversationDetailsSkip', sectionName: 'Conversation Details__Skip', isExpanded: false },
            { sectionKey: 'userComponentUsages', sectionName: 'User Component Usages', isExpanded: false }
        ]);
    }
}

